import { UsageReportsConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const  UsageActions = {
    searchUsage,
};

function searchUsage(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: UsageReportsConstants.SEARCH_USAGEREPORTS_REQUEST,
            data: null
        }));
        adminUsersServices.UsageReport(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: UsageReportsConstants.SEARCH_USAGEREPORTS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: UsageReportsConstants.SEARCH_USAGEREPORTS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: UsageReportsConstants.SEARCH_USAGEREPORTS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}